<template>
    <div class="pictures">
        <site-img
            class="single-picture"
            v-if="!!usePicture"
            type="bgImg"
            :src="usePicture || ''"
            :alt="(usePicture && usePicture.alt) || imgAlt"
            :lazy="false"
        />
        <template v-else>
            <!--<site-img
                class="single-picture"
                type="bgImg"
                :src="firstImgUrl"
            ></site-img>-->
            <Swiper class="pictures-list" v-bind="swiperOption" @init="onSwiperInit" v-if="!updateEffect">
                <Slide
                    class="list-item img-content"
                    v-for="(picture, index) in list"
                    :key="'pictures-list' + index"
                >
                    <site-img
                        class="item-img"
                        :src="picture.imgUrl"
                        :alt="picture.alt || imgAlt"
                        :lazy="index !== 0"
                    />
                </Slide>
            </Swiper>
            <div v-show="showPagination" class="swiper-pagination"></div>
        </template>
    </div>
</template>

<script>
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';

export default {
    props: {
        options: {
            type: Object,
            default: () => ({})
        },
        showPagination: {
            type: Boolean,
            default: false
        },
        pictureList: {
            type: Array,
            default: () => []
        },
        imgAlt: {
            type: String,
            default: () => 'background banner'
        },
        rawDot: {
            type: Boolean,
            default: false
        }
    },
    data: function() {
        return {
            swiper: null,
            updateEffect: false
        };
    },
    computed: {
        firstImgUrl() {
            try {
                return this.list[0].imgUrl;
            } catch {
                return '';
            }
        },
        isSingleImage() {
            return this.pictureList.length === 1;
        },
        usePicture() {
            if (this.pictureList.length === 1) {
                return this.pictureList[0];
            }
            return '';
        },
        list() {
            return this.pictureList.map(pic => {
                if (typeof pic === 'string') {
                    pic = {
                        imgUrl: pic
                    };
                }

                return pic;
            });
        },
        swiperOption({ options }) {
            let oldOpt = options;
            let opts = {
                //  One graph blocks the looping pattern
                loop: true,
                speed: 1000,
                autoplay: {
                    delay: options?.slideDelay
                        ? parseInt(options.slideDelay) * 1000
                        : 8000,
                    disableOnInteraction: false
                }
            };
            if (this.showPagination) {
                opts.pagination = {
                    el: '.swiper-pagination',
                    closest: '.pictures',
                    clickable: true
                };
                if (!this.rawDot) {
                    opts.pagination.type = 'custom';
                    opts.pagination.renderCustom = function(swiper, current, total) {
                        let _html = '';
                        let width = 150 / total;
                        _html = `<span class="broker-hero-custom-pagination-number">${current}/${total}</span>`;
                        for (let i = 1; i <= total; i++) {
                            _html +=
                                current == i
                                    ? `<span class="broker-hero-pagination-bullet active" style="width:${width}px"></span>`
                                    : `<span class="broker-hero-pagination-bullet" style="width:${width}px"></span>`;
                        }
                        return _html;
                    }
                }
            }
               
            // this
            return fixSwiperOptions(Object.assign(opts, oldOpt));
        }
    },
    methods: {
        onSwiperInit(swiper) {
            this.swiper = swiper;
        }
    },
    components: {
        Swiper,
        Slide: SwiperSlide
    },
    watch: {
        swiperOption() {
            this.updateEffect = true
            this.$nextTick(() => {
                this.updateEffect = false
            })
            // this.$nextTick(()=>{
            //     this.swiper && this.swiper.update();
            // });
        }
    }
}
</script>

<style lang="scss">
@import '../theme/mixin.scss';
.pictures {
    .pictures-list {
        overflow: hidden;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        .list-item {
            width: 100%;
            height: 100%;
            overflow: hidden;
            .item-img {
                width: 100%;
                height: 100%;
                @include object-fit(cover);
            }
        }
    }
}
</style>
